import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Table, Data } from 'components/layout/Table'
import { AssessorsTableRow } from 'components/sections/assessors'
import { assessors as assessorsLayout } from 'constants/layout'

export default class AssessorsTable extends Component {
  static propTypes = {
    assessors: PropTypes.object.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    permissions: PropTypes.object.isRequired,
    organizationHierarchyId: PropTypes.number,
    setAssessorsParams: PropTypes.func,
    expiredWWC: PropTypes.bool,
    onRemindExpiredWWC: PropTypes.func
  }

  static defaultProps = {
    permissions: {},
    params: {},
    activeOrganization: {},
    expiredWWC: false
  }

  render() {
    const {
      assessors: { loading, list, offset, limit, pages, sort } = {},
      setAssessorsParams,
      permissions,
      params,
      activeOrganization,
      expiredWWC,
      onRemindExpiredWWC
    } = this.props

    return (
      <div>
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          pages={pages}
          sort={sort}
          ths={assessorsLayout.tableHeaders(expiredWWC)}
          setParams={setAssessorsParams}
          permissions={permissions}
        >
          <Data>
            {list.map(item => (
              <AssessorsTableRow
                key={item.id}
                data={item}
                params={params}
                permissions={permissions}
                activeOrganization={activeOrganization}
                expiredWWC={expiredWWC}
                onRemindExpiredWWC={onRemindExpiredWWC}
              />
            ))}
          </Data>
        </Table>
      </div>
    )
  }
}
